export default "__VITE_ASSET__BZ1oGdb1__"